import { render, staticRenderFns } from "./StandardClauseList.vue?vue&type=template&id=3c2f8a0d&"
import script from "./StandardClauseList.vue?vue&type=script&lang=js&"
export * from "./StandardClauseList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports